module.exports = __webpack_public_path__ + "static/media/undraw_quite_town_mg2q.84e74862.svg";